import { encrypt, decrypt } from './crypto';

const CREDENTIALS_KEY = 'nova-content-credentials';

interface StoredCredentials {
  email: string;
  password: string;
}

export const saveCredentials = (email: string, password: string): void => {
  try {
    const credentials = encrypt(JSON.stringify({ email, password }));
    localStorage.setItem(CREDENTIALS_KEY, credentials);
  } catch (error) {
    console.error('Error saving credentials:', error);
  }
};

export const getStoredCredentials = (): StoredCredentials | null => {
  try {
    const encrypted = localStorage.getItem(CREDENTIALS_KEY);
    if (!encrypted) return null;

    const decrypted = decrypt(encrypted);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error('Error retrieving credentials:', error);
    return null;
  }
};

export const clearStoredCredentials = (): void => {
  localStorage.removeItem(CREDENTIALS_KEY);
};